import React, { useEffect, useState, useContext } from 'react'

import { GREEN_CHECK_ICON, VALIDATION_ERROR_ICON } from '../../constants/urls'
import { DataContext } from '../../context/DataContext'
import { useApi } from '../../hooks/useApi'

import Modal from '../shared/Modal'
import Input from '../shared/Input'
import SubmitButton from '../shared/SubmitButton'
import Button from '../shared/Button'
import Loader from '../shared/Loader'

const AuthModal: React.FC = () => {
  const {
    sale,
    companyColor,
    openAuthStep: step,
    setOpenAuthStep: setStep,
    setOpenPopUp
  } = useContext(DataContext)
  const { verifyMail } = useApi()

  const [tab, setTab] = useState('mail')
  const [modalInput, setModalInput] = useState('')
  const [description, setDescription] = useState('')
  const [errorMessage, setErrorMessage] = useState('')
  const [status, setStatus] = useState<'success' | 'error' | 'loading' | null>(null)

  const handleAuth = async () => {
    setStatus('loading')
    const response = await verifyMail(modalInput, sale.orderId, tab)
    if (response.authToken) {
      setStatus('success')

      setTimeout(() => {
        setStatus(null)
        setErrorMessage('')
        setStep(0)
      }, 2000)
    }
    if (response.error) {
      setErrorMessage(response.error)
      setStatus('error')
      setOpenPopUp(true)
    }
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (tab === 'phone') {
      if (e.target.value.length === 0) {
        setModalInput('')
        return
      }
      if (!/^[0-9+]+$/.test(e.target.value) || e.target.value.length > 12) {
        return
      }
    }
    setModalInput(e.target.value)
  }

  const handleRetry = () => {
    setStatus(null)
    setStep(2)
  }

  useEffect(() => {
    if (step === 1) {
      setDescription('Para acceder a esta información, necesitas verificar tus datos de compra')
    } else {
      setDescription('Elige con que dato quieres validar tu identidad')
    }
  }, [step])

  if (step === 0) return null
  if (status === 'loading') { return (
    <Modal show>
      <div className='flex flex-col justify-center w-full my-8'>
        <Loader />
        <p className='text-center mt-3 text-sm'>Validando</p>
      </div>
    </Modal>
  )}

  if (status === 'success') { return (
    <Modal show>
      <div className='flex flex-col justify-center items-center my-8'>
        <div className='flex rounded-full justify-center items-center border-4 border-green w-16 h-16'>
          <img src={GREEN_CHECK_ICON} alt="check" className='w-10 h-10' />
        </div>
        <h1 className='text-center mt-3 text-sm'>Listo</h1>
      </div>
    </Modal>
  )}

  if (status === 'error') { return (
    <Modal show>
      <div className='flex flex-col justify-center items-center mt-4'>
        <div className='flex rounded-full justify-center items-center'>
          <img src={VALIDATION_ERROR_ICON} alt="check" className='w-16 h-16' />
        </div>
        <h1 className='text-center mt-4 text-lg font-[Onest] font-semibold'>{errorMessage}</h1>

        <div className='flex flex-col gap-2 w-full mt-8'>
          <div className='h-12'>
            <Button companyColor={companyColor} dark onClick={handleRetry} text="Reintentar" />
          </div>
          <div className='h-12'>
            <Button companyColor={companyColor} dark={false} onClick={() => setStep(0)} text="Salir" />
          </div>
        </div>
      </div>
    </Modal>
  )}

  return (
    <Modal
      show={step > 0}
      title="Verifica tu identidad"
      description={description}
    >
      {step === 2 && (
        <div className='flex justify-center w-full mt-8 md:text-lg text-sm'>
          <button className={`${tab === 'mail' ? 'font-bold border-b-2 border-black text-black' : 'border-b border-gray-500 text-gray-500'} w-1/2`} type="button" onClick={() => setTab('mail')}>Mail </button>
          <button className={`${tab === 'phone' ? 'border-b-2 font-bold border-black text-black' : 'border-b border-gray-500 text-gray-500'} w-1/2`} type="button" onClick={() => setTab('phone')}>Teléfono </button>
        </div>
      )}

      <form onSubmit={(e) => {e.preventDefault(); handleAuth()}}>
        {step === 2 && <div className='md:mb-6 mb-4 mt-2 h-14'>
          <Input
            placeholder={`${tab === 'mail' ? 'Mail' : 'Teléfono'}`}
            searchBarInput={modalInput}
            handleChange={handleChange}
            type={tab === 'mail' ? 'email' : 'tel'}
          />
        </div>}

        <div className='h-12 mt-4'>
          {step === 2 && <SubmitButton text="Verificar" companyColor={companyColor} dark />}
          {step === 1 && <Button text="Continuar" companyColor={companyColor} dark onClick={() => setStep(2)} />}
        </div>
      </form>

      <div className={`${step === 2 ? 'h-8 mt-2' : 'mt-2 h-12'}`}>
        <Button
          text="Cancelar"
          companyColor={companyColor}
          dark={false}
            onClick={() => setStep(0)}
          />
      </div>
    </Modal>
  )
}

export default AuthModal
